import * as Types from './types'

export default {
  [Types.SET_BRANDS]: (state, payload) => {
    state.brands = payload
  },
  [Types.SET_SELECTED_BRAND]: (state, payload) => {
    state.selectedBrand = payload
  },
  [Types.SET_ADMIN_EMAIL]: (state, payload) => {
    state.adminEmail = payload
  },
  [Types.SET_FIN_YEAR]: (state, payload) => {
    state.finYear = payload
  },
  [Types.SET_ROLE_AND_PERMISSIONS]: (state, payload) => {
    state.roleAndPermission = payload
  },
  [Types.SET_BRAND_FIN_YEAR]: (state, payload) => {
    state.brandFinYear = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/global/mutations.js